import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Qanunvericilik.css";

const MxfilikSiyaseti = () => {
  return (
    <div className="qanunvericilik-page">
      <Helmet>
        <title>Məxfilik siyasəti | DostTech</title>
        <meta
          name="description"
          content="DostTech.az məxfilik siyasəti — veb-saytdan istifadə zamanı məlumatların toplanması, qorunması və istifadəsi qaydaları."
        />
      </Helmet>
      <div className="container qanunvericilik-inner">
        <h1 className="qanunvericilik-title">Məxfilik siyasəti</h1>

        <section
          className="qanunvericilik-section"
          aria-labelledby="privacy-policy-heading"
        >
          <h2 id="privacy-policy-heading" className="visually-hidden">
            Məxfilik siyasətinin məzmunu
          </h2>
          <p>
            {`Bu Məxfilik Siyasəti istifadəçilər (bundan sonra — istifadəçi və ya siz) tərəfindən "dosttech.az" (bundan sonra veb-sayt) ziyarət olunan, təklif olunmuş xidmətlərdən istifadə edilən və ya bizimlə əlaqə saxlanılan zaman əldə edilmiş məlumatların (fərdi və texniki) toplanması, istifadəsi, qorunması, açıqlanması və verilməsi qaydalarını müəyyənləşdirir.`}
          </p>
          <p className="mt-3 mb-0">
            {`Fərdi məlumatlar Azərbaycan Respublikası qanunvericiliyi ilə müəyyən edilən səlahiyyət və vəzifələrinin icra olunması üçün "Fərdi məlumatlar haqqında" Azərbaycan Respublikası Qanununun tələblərinə uyğun olaraq toplanılır, işlənilir və mühafizə olunur.`}
          </p>
        </section>
      </div>
    </div>
  );
};

export default MxfilikSiyaseti;
